const NebuleSkyShader = {
  vertexShader: /* glsl */ `
     precision highp float;

      attribute vec3 position;
      attribute vec3 normal;
      attribute vec2 uv;

      uniform mat4 modelViewMatrix;
      uniform mat4 projectionMatrix;

      varying vec2 vUv;

      void main() {
        vUv = uv;
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
      }

  `,

  fragmentShader: /* glsl */ `
    precision mediump float;

      uniform float time;
      uniform sampler2D texture;
      uniform sampler2D flowMap;
      uniform float flowStrength;
      uniform float cycleDuration;
      uniform float alphaMultiplier;
      uniform vec2 offsetTex;
      
      varying vec2 vUv;

      vec2 center_rot_scale(vec2 v, float rot, float scale) {
        vec2 center = vec2(0.5, 0.5);
        v -= center; // subtract pivot
        float c = cos(rot), s = sin(rot);
        mat2 m = mat2(c, s, -s, c);
        v = m * v; // rotate
        v *= scale; // scale
        v += center; // add pivot
        return v;
      }

      float circle_alpha(vec2 uv) {
        float dist = distance(uv, vec2(0.5, 0.5)) * 2.0;
        return 1.0 - min(dist, 1.0);
      }
      
      void main()
      {
        float t1, t2;
        vec2 uv1, uv2;
        vec4 color_out, color1, color2;
        float alpha1, alpha2, alpha, rot, scale, blend;

        // Look up the flow direction from the flow map.
        // Use two cycles, offset by a half so we can blend between them
        vec2 flowDir = (texture2D(flowMap, vUv).rg - 0.5) * 2.0 * flowStrength;
        t1 = time / cycleDuration;
        t2 = t1 + 0.5;
        t1 = t1 - floor(t1);
        t2 = t2 - floor(t2);
        uv1 = vUv + (flowDir * t1);
        uv2 = vUv + (flowDir * t2);
        blend = abs(t1-0.5)*2.0;

        // Base layer 1 
        color1 = texture2D(texture, uv1 + offsetTex);
        color2 = texture2D(texture, uv2 + offsetTex);
        color_out = mix(color1, color2, blend);
        color_out.g *= 0.65;
        color_out.b *= 1.0;
        alpha1 = circle_alpha(uv1);
        alpha2 = circle_alpha(uv2);
        alpha = mix(alpha1, alpha2, blend);

        // Layer 2
        scale = 0.5;
        rot = 0.1 * time;
        // Offset in opposite directions - this shouldn't blend perfectly
        // but since the layer is additive and subtle it looks nice
        color1 = texture2D(texture, center_rot_scale(uv1, rot, scale) - offsetTex);
        color2 = texture2D(texture, center_rot_scale(uv2, rot, scale) + offsetTex);
        color1.g *= 0.5;
        color2.g *= 0.5;
        color2.r *= 1.2;
        color2.b *= 1.5;
        color_out += mix(color1, color2, blend); // mix
        alpha1 = circle_alpha(center_rot_scale(uv1, rot, 2.0));
        alpha2 = circle_alpha(center_rot_scale(uv2, rot, 2.0));
        alpha += mix(alpha1, alpha2, blend);

        alpha = min(1.0, alpha); // clamp
        
        color_out.a = alpha * alphaMultiplier;
        color_out.a *= circle_alpha(vUv);
      }
  `,
};

export default NebuleSkyShader;
